import { MarketAccountStatusEnum, type MarketAccount } from '@talos/kyoko';

interface ResolveCustomerMarketAccountsForBalanceDrawerParams {
  customer: string | undefined;
  disableCustomerMarketAccounts: boolean;
  getActiveCustomerMarketAccounts: (customer: string) => MarketAccount[];
  marketAccountsByCounterparty: Map<string, MarketAccount[]>;
}

/**
 * Prefer the dedicated CustomerMarketAccounts stream (not segregation-filtered).
 * When `ui.DisableCustomerMarketAccounts` is on, that stream is empty — fall back to MarketAccounts.
 */
export function resolveCustomerMarketAccountsForBalanceDrawer({
  customer,
  disableCustomerMarketAccounts,
  getActiveCustomerMarketAccounts,
  marketAccountsByCounterparty,
}: ResolveCustomerMarketAccountsForBalanceDrawerParams): MarketAccount[] {
  if (!customer) {
    return [];
  }

  if (disableCustomerMarketAccounts) {
    return marketAccountsByCounterparty.get(customer)?.filter(ma => ma.Status === MarketAccountStatusEnum.Active) ?? [];
  }

  return getActiveCustomerMarketAccounts(customer);
}
